import React from 'react';
import { Home } from 'lucide-react';
import { CreditCard, User, LogOut, Sparkles } from 'lucide-react';

const Header = ({ user, credits, activeTab, setActiveTab, handleLogout,targetSystem  }) => {
  return (
   <div className="bg-white shadow-sm border-b border-gray-200">
  <div className="max-w-[1800px] mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl">
              
              <Sparkles className="w-6 h-6 text-white" />
              
            </div>
            <div>
              <h1 className="text-lg font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                AP Invoice Processor
              </h1>
              <div className="flex items-center gap-2 mb-2">
                <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-bold rounded-full border border-green-300">
                  ✓ QuickBooks®
                </span>
                <span className="px-3 py-1 bg-indigo-100 text-indigo-700 text-xs font-bold rounded-full border border-indigo-300">
                  ✓ Coupa®
                </span>
              </div>
              <p className="text-sm text-gray-600">Smart Invoice Processor • Multi-System Support</p>
            </div>
          </div>
          
          
          {user && (
            <div className="flex items-center gap-4">
              {user && activeTab === 'invoice' && (
  <button
    onClick={() => {
      // Reset to upload state
      window.location.reload(); // Simple approach - reloads the page
    }}
    className="flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all text-gray-600 hover:bg-gray-100"
  >
    <Home className="w-4 h-4" />
    <span>Home</span>
  </button>
)}
              <div className="flex items-center gap-2 bg-gradient-to-r from-indigo-50 to-purple-50 px-4 py-2 rounded-lg border border-indigo-200">
                <CreditCard className="w-5 h-5 text-indigo-600" />
                <span className="font-semibold text-indigo-600">{credits} Credits</span>
              </div>
              
              <div className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-lg">
                <User className="w-5 h-5 text-gray-600" />
                <span className="text-sm text-gray-700">{user.name}</span>
              </div>
              
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition"
              >
                <LogOut className="w-5 h-5" />
                Logout
              </button>
            </div>
          )}
        </div>

        {/* Navigation Tabs */}
        <div className="flex gap-2 mt-4 border-b border-gray-200">
          <button
            onClick={() => setActiveTab('invoice')}
            className={`px-4 py-2 text-sm font-medium transition-all relative ${
              activeTab === 'invoice'
                ? 'text-indigo-600 border-b-2 border-indigo-600'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Invoice Processing
          </button>
          <button
            onClick={() => setActiveTab('instructions')}
            className={`px-4 py-2 text-sm font-medium transition-all relative ${
              activeTab === 'instructions'
                ? 'text-indigo-600 border-b-2 border-indigo-600'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Instructions
          </button>
          <button
            onClick={() => setActiveTab('pricing')}
            className={`px-4 py-2 text-sm font-medium transition-all relative ${
              activeTab === 'pricing'
                ? 'text-indigo-600 border-b-2 border-indigo-600'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Pricing
          </button>
          
          {user && targetSystem === 'coupa' && (
  <button
    onClick={() => setActiveTab('configuration')}
    className={`px-4 py-2 rounded-lg font-medium transition-all ${
      activeTab === 'configuration'
        ? 'bg-indigo-600 text-white'
        : 'text-gray-600 hover:bg-gray-100'
    }`}
  >
    Configuration
  </button>
)}

          {user?.isAdmin && (
            <button
              onClick={() => setActiveTab('admin')}
              className={`px-4 py-2 text-sm font-medium transition-all relative ${
                activeTab === 'admin'
                  ? 'text-indigo-600 border-b-2 border-indigo-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Admin
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;